import { combineEpics } from "redux-observable";
import { epicPendingInventoryCollectRewards } from "./epics/epicPendingInventoryCollectRewards";
import { epicPendingInventoryInfo } from "./epics/epicPendingInventoryInfo";
export var epicPendingInventory = combineEpics(epicPendingInventoryInfo, epicPendingInventoryCollectRewards);



//////////////////
// WEBPACK FOOTER
// ./src/features/pending-inventory/epicPendingInventory.ts
// module id = 2035
// module chunks = 3